// ============================================================================
// CASE TYPE ENDPOINTS — Phase 8a
// ============================================================================
// BASE_PATH must match backend CaseTypeController route token (/CaseType).

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const CASE_TYPE_BASE_PATH = '/CaseType';

export const caseTypeEndpoints = {
  list: () => buildEndpoint(CASE_TYPE_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${CASE_TYPE_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${CASE_TYPE_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(CASE_TYPE_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${CASE_TYPE_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${CASE_TYPE_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${CASE_TYPE_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default caseTypeEndpoints;
